<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
      <mask
        id="RfConversionPathMask"
        width="40"
        height="40"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="#d9d9d9" d="M0 0h40v40H0z" />
      </mask>
      <g mask="url(#RfConversionPathMask)">
        <path
          fill="inherit"
          stroke="none"
          d="M31.75 34.17a4 4 0 0 1-4.03-3.38h-9.35a5.6 5.6 0 0 1-4.08-1.66 5.6 5.6 0 0 1-1.66-4.09q0-2.43 1.66-4.09a5.6 5.6 0 0 1 4.08-1.65h3.3q1.8 0 3.07-1.27A4.2 4.2 0 0 0 26 14.95q0-1.8-1.26-3.07a4.2 4.2 0 0 0-3.07-1.26h-9.4q-.21 1.47-1.36 2.42-1.15.96-2.66.96-1.7 0-2.9-1.18a4 4 0 0 1-1.18-2.9q0-1.7 1.19-2.9 1.2-1.19 2.9-1.19a4 4 0 0 1 4.02 3.38h9.39q2.43 0 4.08 1.66a5.6 5.6 0 0 1 1.66 4.09q0 2.43-1.66 4.09a5.6 5.6 0 0 1-4.08 1.66h-3.3q-1.8 0-3.07 1.26a4.2 4.2 0 0 0-1.26 3.08q0 1.8 1.26 3.07a4.2 4.2 0 0 0 3.07 1.26h9.35q.24-1.47 1.37-2.42a4 4 0 0 1 2.66-.96q1.7 0 2.9 1.18 1.18 1.17 1.18 2.9 0 1.7-1.19 2.9-1.2 1.19-2.9 1.19M8.25 12.59q1.1 0 1.9-.78.78-.78.78-1.9 0-1.1-.79-1.88a2.6 2.6 0 0 0-1.89-.79q-1.1 0-1.9.79a2.6 2.6 0 0 0-.77 1.89q0 1.1.78 1.9.78.77 1.9.77"
        />
      </g>
    </svg>
  </span>
</template>
